<template>
  <div>
    <v-card :loading="loading">
      <div
        class="primary pa-3 d-flex justify-space-between align-center white--text"
        color="primary"
      >
        <div>
          <h1 class="text-h5">{{ fund.shortName || fund.name }}</h1>
          <h2 class="mt-0 text-subtitle-1 font-weight-light">
            CNPJ: {{ fund.document }}
          </h2>
        </div>
      </div>
      <v-card-text>
        <v-row>
          <v-col>
            <v-flex class="mt-1">
              <v-simple-table>
                <tbody>
                  <tr>
                    <td>Data registro</td>
                    <td>
                      {{
                        moment(fund.registerDate).tz("UTC").format("DD/MM/YYYY")
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Data inicial</td>
                    <td>
                      {{
                        moment(fund.initialDate).tz("UTC").format("DD/MM/YYYY")
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Gestor</td>
                    <td>
                      {{ fund.manager ? fund.manager.name : "" }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-flex>
          </v-col>
          <v-col>
            <v-flex class="mt-1">
              <v-simple-table>
                <tbody>
                  <tr>
                    <td>
                      Patrimônio em
                      {{
                        fund.lastFullHistory && fund.lastFullHistory.date
                          ? moment(fund.lastFullHistory.date)
                              .tz("UTC")
                              .format("DD/MM/YYYY")
                          : null
                      }}
                    </td>
                    <td>
                      {{
                        fund.lastFullHistory && fund.lastFullHistory.equity
                          ? `R$${Number(
                              fund.lastFullHistory.equity
                            ).toLocaleString("pt")}`
                          : "--"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Classe</td>
                    <td>{{ fund.class }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-flex>
          </v-col>
        </v-row>
      </v-card-text>
      <v-simple-table class="text-center">
        <thead>
          <tr>
            <th class="text-center primary white-border white--text">
              {{
                fund.history && fund.history.date
                  ? moment.utc(fund.history.date).format("DD/MM/YYYY")
                  : "--"
              }}
            </th>
            <th class="text-center primary white-border white--text">MTD</th>
            <th class="text-center primary white-border white--text">6M</th>
            <th class="text-center primary white-border white--text">12M</th>
            <th class="text-center primary white-border white--text">24M</th>
            <th class="text-center primary white-border white--text">YTD</th>
            <th class="text-center primary white-border white--text">BTD</th>
            <th class="text-center primary white-border white--text">VOL 3M</th>
            <th class="text-center primary white-border white--text">VOL 6M</th>
            <th class="text-center primary white-border white--text">
              VOL 12M
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td :class="textColor(fund.history.performance)">
              {{ percent(fund.history.performance) }}
            </td>
            <td :class="textColor(fund.history.mtd)">
              {{ percent(fund.history.mtd) }}
            </td>
            <td :class="textColor(fund.history.m6)">
              {{ percent(fund.history.m6) }}
            </td>
            <td :class="textColor(fund.history.m12)">
              {{ percent(fund.history.m12) }}
            </td>
            <td :class="textColor(fund.history.m24)">
              {{ percent(fund.history.m24) }}
            </td>
            <td :class="textColor(fund.history.ytd)">
              {{ percent(fund.history.ytd) }}
            </td>
            <td :class="textColor(fund.history.btd)">
              {{ percent(fund.history.btd) }}
            </td>
            <td>{{ percent(fund.history.vol3) }}</td>
            <td>{{ percent(fund.history.vol6) }}</td>
            <td>{{ percent(fund.history.vol12) }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
  </div>
</template>

<style scoped>
.manager-link {
  color: #000;
  text-decoration: none;
}
.fund-info-date {
  text-align: center;
  min-width: 90px !important;
  display: inline-block;
  border-bottom: dashed 1px #999;
  cursor: pointer;
}
.fund-info-date-wrapper {
  max-width: 170px !important;
}
</style>

<script>
import moment from 'moment-loyall';

export default {
  name: 'BasicInformation',

  components: {},

  props: {
    fund: {
      type: Object,
      default: () => ({}),
    },

    user: {
      type: Object,
      default: () => ({}),
    },

    loading: {
      type: Boolean,
      required: false,
    },
  },

  methods: {
    fundUpdated(fundData) {
      this.$emit('update:fund', fundData);
    },
    percent(number) {
      const THRESHOLD = -80;

      const percentage = Number.parseFloat(number) * 100;

      if (!Number.isFinite(percentage) || percentage < THRESHOLD) {
        return '---';
      }

      return `${percentage.toFixed(2).replace('.', ',')}%`;
    },
    textColor(val) {
      const THRESHOLD = -0.8;
      const number = Number.parseFloat(val);

      if (!Number.isFinite(number) || number < THRESHOLD || number === 0) {
        return '';
      }

      if (number > 0) {
        return 'green--text';
      }

      return 'red--text';
    },
  },
  data: () => ({
    moment,
  }),
};
</script>
